
import React from 'react';

const PricingHeader = () => {
  return (
    <div className="text-center mb-16">
      <h1 className="text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl mb-4 animate-slide-up [animation-delay:100ms] opacity-0">
        Choose Your Plan
      </h1>
      <p className="max-w-2xl mx-auto text-lg text-muted-foreground animate-slide-up [animation-delay:200ms] opacity-0">
        Flexible pricing for every artist. Save big with annual or lifetime access!
      </p>
    </div>
  );
};

export default PricingHeader;
